
import { returnCheckList, stringContact } from './utilities-function';
import { environment } from 'src/environments/environment';

export const TERMS_AND_CONDITIONS_CHECK_LIST = [
    {
        id: 1,
        check_list: [
            `<span><span class="fw-bold">“ผู้ให้บริการ”</span> หมายถึง <span class='text-primary fw-bold'>${environment.appName}</span></span>`,
            `<span><span class="fw-bold">“ผู้ใช้งาน”</span> หมายถึง บุคคลที่สมัครสมาชิกหรือใช้งานเว็บไซต์</span>`,
            `<span><span class="fw-bold">“คอร์ส”</span> หมายถึง หลักสูตร บทเรียน วิดีโอ เอกสาร แบบทดสอบ หรือเนื้อหาอื่น ๆ ที่ให้บริการผ่านเว็บไซต์</span>`,
            `<span><span class="fw-bold">“บัญชีผู้ใช้งาน”</span> หมายถึง บัญชีที่ผู้ใช้งานสร้างขึ้นเพื่อเข้าถึงบริการของเว็บไซต์</span>`,
        ]
    },
    {
        id: 2,
        check_list: [
            `<span>ให้ข้อมูลที่ถูกต้อง ครบถ้วน และเป็นปัจจุบัน</span>`,
            `<span>รักษาชื่อผู้ใช้งานและรหัสผ่านไว้เป็นความลับ</span>`,
            `<span>ไม่อนุญาตให้บุคคลอื่นใช้บัญชีของตน เว้นแต่เงื่อนไขของคอร์สจะระบุไว้เป็นอย่างอื่น</span>`,
            `<span>หากพบการเข้าถึงบัญชีโดยไม่ได้รับอนุญาต ต้องแจ้งผู้ให้บริการโดยเร็ว</span>`,
            `<span>ผู้ให้บริการมีสิทธิระงับหรือยกเลิกบัญชีที่มีการใช้งานผิดเงื่อนไข</span>`,
        ]
    },
    {
        id: 3,
        check_list: []
    },
    {
        id: 4,
        check_list: [
            `<span>Mobile Banking</span>`,
            `<span>QR Payment</span>`,
            `<span>ช่องทางการชำระเงินอื่นที่เว็บไซต์รองรับ</span>`,
        ]
    },
    {
        id: 5,
        check_list: []
    },
    {
        id: 6,
        check_list: [
            `<span>วิดีโอ</span>`,
            `<span>รูปภาพ</span>`,
            `<span>เอกสารประกอบการเรียน</span>`,
            `<span>แบบทดสอบ</span>`,
            `<span>เสียง</span>`,
            `<span>ข้อความ</span>`,
            `<span>เครื่องหมายการค้า</span>`,

            `<span>คัดลอกหรือทำซ้ำเนื้อหา</span>`,
            `<span>ดาวน์โหลดเนื้อหาโดยไม่ได้รับอนุญาต</span>`,
            `<span>เผยแพร่หรือแจกจ่ายต่อ</span>`,
            `<span>จำหน่ายต่อ</span>`,
            `<span>บันทึกหน้าจอหรือบันทึกวิดีโอเพื่อเผยแพร่ต่อ</span>`,
            `<span>แชร์บัญชีเพื่อให้บุคคลอื่นเข้าถึงคอร์ส</span>`,
            `<span>นำเนื้อหาไปใช้ในเชิงพาณิชย์โดยไม่ได้รับอนุญาต</span>`,
        ]
    },
    {
        id: 7,
        check_list: []
    },
    {
        id: 8,
        check_list: [
            `<span>กระทำการที่ผิดกฎหมาย</span>`,
            `<span>พยายามเข้าถึงระบบโดยไม่ได้รับอนุญาต</span>`,
            `<span>เจาะระบบหรือทดสอบช่องโหว่โดยไม่ได้รับอนุญาต</span>`,
            `<span>รบกวนการทำงานของเว็บไซต์</span>`,
            `<span>ใช้ Bot หรือโปรแกรมอัตโนมัติเพื่อดึงข้อมูลโดยไม่ได้รับอนุญาต</span>`,
            `<span>เผยแพร่เนื้อหาที่ละเมิดสิทธิของบุคคลอื่น</span>`,
            `<span>ใช้บัญชีของบุคคลอื่นโดยไม่ได้รับอนุญาต</span>`,
        ]
    },
    {
        id: 9,
        check_list: [
            `<span>การบำรุงรักษาระบบ</span>`,
            `<span>ปัญหาด้านเซิร์ฟเวอร์</span>`,
            `<span>ปัญหาจากผู้ให้บริการภายนอก</span>`,
            `<span>เหตุสุดวิสัย</span>`,
            `<span>เหตุการณ์อื่นที่อยู่นอกเหนือการควบคุมของผู้ให้บริการ</span>`,
        ]
    },
    {
        id: 10,
        check_list: [

        ]
    },
    {
        id: 11,
        check_list: [
            `<span>ข้อมูลที่ให้ไว้กับเว็บไซต์</span>`,
            `<span>การใช้งานบัญชีของตน</span>`,
            `<span>การรักษาข้อมูลการเข้าสู่ระบบ</span>`,
            `<span>การใช้งานเนื้อหาตามข้อตกลง</span>`,
            `<span>การกระทำใด ๆ ที่เกิดขึ้นผ่านบัญชีของตน</span>`,
        ]
    },
    {
        id: 12,
        check_list: [
            `<span>ฝ่าฝืนข้อตกลง</span>`,
            `<span>แชร์บัญชี</span>`,
            `<span>คัดลอกหรือเผยแพร่เนื้อหาโดยไม่ได้รับอนุญาต</span>`,
            `<span>กระทำการที่อาจก่อให้เกิดความเสียหายต่อเว็บไซต์หรือผู้ใช้งานรายอื่น</span>`,
            `<span>กระทำการที่ผิดกฎหมาย</span>`,
        ]
    },
    {
        id: 13,
        check_list: [

        ]
    },
    {
        id: 14,
        check_list: [

        ]
    },
    {
        id: 15,
        check_list: [

        ]
    },
    {
        id: 16,
        check_list: [

        ]
    },
]

export const TERMS_AND_CONDITIONS = [
    {
        id: 1,
        name: 'คำนิยาม',
        content: `
        <p class="mb-0">ในข้อตกลงนี้</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 1 })}
        `
    },
    {
        id: 2,
        name: 'การสมัครสมาชิก',
        content: `
        <p class="mb-0">ผู้ใช้งานตกลงว่า</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 2, bullet: 'number' })}
        `
    },
    {
        id: 3,
        name: 'การสั่งซื้อคอร์ส',
        content: `เมื่อผู้ใช้งานเลือกคอร์สและดำเนินการสั่งซื้อ ผู้ใช้งานตกลงชำระค่าบริการตามราคาที่แสดงบนเว็บไซต์ ราคาของคอร์ส โปรโมชั่น ส่วนลด และสิทธิประโยชน์ต่าง ๆ อาจเปลี่ยนแปลงได้ตามที่ผู้ให้บริการกำหนด โดยการเปลี่ยนแปลงราคาจะไม่กระทบต่อคำสั่งซื้อที่ได้รับการยืนยันแล้ว เว้นแต่กรณีที่เกิดจากข้อผิดพลาดของระบบหรือข้อมูลราคา`
    },
    {
        id: 4,
        name: 'การชำระเงิน',
        content: `
        <p class="mb-0">ผู้ใช้งานสามารถชำระค่าบริการผ่านช่องทางที่เว็บไซต์กำหนด เช่น</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 4 })}
        <p class="mb-0">คำสั่งซื้อจะถือว่าสมบูรณ์เมื่อระบบได้รับการยืนยันการชำระเงินตามเงื่อนไขที่กำหนด <br/>
        หากการชำระเงินไม่สำเร็จ ผู้ให้บริการอาจไม่เปิดสิทธิ์การเข้าถึงคอร์สจนกว่าจะได้รับการชำระเงินครบถ้วน</p>
        `
    },
    {
        id: 5,
        name: 'การเข้าถึงคอร์ส',
        content: `เมื่อการชำระเงินได้รับการยืนยัน ผู้ใช้งานจะได้รับสิทธิ์เข้าถึงคอร์สตามระยะเวลาและเงื่อนไขที่ระบุไว้ในหน้าคอร์ส สิทธิ์ในการเข้าถึงคอร์สเป็น สิทธิ์ส่วนบุคคล และไม่สามารถโอน ขาย ให้เช่า หรือมอบสิทธิ์แก่บุคคลอื่น เว้นแต่ผู้ให้บริการจะอนุญาตเป็นลายลักษณ์อักษร`
    },
    {
        id: 6,
        name: 'การใช้เนื้อหาของคอร์ส',
        content: `
        <p class="mb-0">เนื้อหาทั้งหมดในคอร์ส เช่น</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 6, index_start: 0, index_end: 6 })}
        <p class="mb-0">เป็นทรัพย์สินทางปัญญาของผู้ให้บริการ ผู้สอน หรือเจ้าของลิขสิทธิ์ที่เกี่ยวข้อง</p>
        <p class="mb-0">ผู้ใช้งานตกลงว่าจะไม่:</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 6, index_start: 7, index_end: 12 })}
        `
    },
    {
        id: 7,
        name: 'การคืนเงินและยกเลิกคำสั่งซื้อ',
        content: `
        <p class="mb-0">
        ผู้ใช้งานรับทราบและตกลงว่า เมื่อยืนยันการสั่งซื้อและชำระเงินสำหรับคอร์สเรียนเรียบร้อยแล้ว รายการสั่งซื้อดังกล่าวถือเป็นรายการที่เสร็จสมบูรณ์ และไม่สามารถยกเลิก เปลี่ยนแปลง หรือขอคืนเงินได้
            <br/>
        ผู้ให้บริการขอสงวนสิทธิ์ในการไม่คืนเงินสำหรับรายการที่มีสถานะการชำระเงินสำเร็จแล้ว ทั้งนี้ ผู้ใช้งานควรตรวจสอบรายละเอียดคอร์ส ราคา และข้อมูลการสั่งซื้อให้ถูกต้องก่อนยืนยันการชำระเงินทุกครั้ง
        </p>
        `
    },
    {
        id: 8,
        name: 'การใช้งานที่ต้องห้าม',
        content: `
        <p class="mb-0">ผู้ใช้งานต้องไม่ใช้เว็บไซต์เพื่อ:</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 8 })}
        `
    },
    {
        id: 9,
        name: 'ความพร้อมใช้งานของระบบ',
        content: `
      <p class="mb-0">ผู้ให้บริการพยายามดูแลให้เว็บไซต์สามารถให้บริการได้อย่างต่อเนื่อง แต่ไม่รับประกันว่าเว็บไซต์จะปราศจากข้อผิดพลาดหรือสามารถใช้งานได้ตลอดเวลา</p>
      <p class="mb-0">เว็บไซต์อาจหยุดให้บริการชั่วคราวเนื่องจาก:</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 9 })}
        `
    },
    {
        id: 10,
        name: 'การเปลี่ยนแปลงเนื้อหาคอร์ส',
        content: `
        <p class="mb-0">
            ผู้ให้บริการหรือผู้สอนอาจปรับปรุง แก้ไข หรือเพิ่มเติมเนื้อหาของคอร์สเพื่อให้ข้อมูลมีความทันสมัยและเหมาะสมกับการเรียนรู้ การเปลี่ยนแปลงดังกล่าวอาจรวมถึงการเพิ่ม ลบ หรือปรับปรุงบทเรียน เอกสาร แบบทดสอบ หรือเนื้อหาอื่น ๆ
        </p>
        `
    },
    {
        id: 11,
        name: 'ความรับผิดชอบของผู้ใช้งาน',
        content: `
        <p class="mb-0">ผู้ใช้งานมีหน้าที่รับผิดชอบต่อ:</p>
        ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 11 })}
        `
    },
    {
        id: 12,
        name: 'การระงับหรือยกเลิกบัญชี',
        content: `
        <p class="mb-0">ผู้ให้บริการอาจระงับหรือยกเลิกบัญชีของผู้ใช้งาน หากพบว่าผู้ใช้งาน:</p>
       ${returnCheckList({ file_data: TERMS_AND_CONDITIONS_CHECK_LIST, check_list_id: 12 })}
        `
    },
    {
        id: 13,
        name: 'การคุ้มครองข้อมูลส่วนบุคคล',
        content: `
            ผู้ให้บริการจะเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งานตาม นโยบายความเป็นส่วนตัว (Privacy Policy) ของเว็บไซต์ และกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่เกี่ยวข้อง
            <a class="fw-bold text-primary text-hover-primary text-hover-underline cursor-pointer" href="/privacy-policy">นโยบายความเป็นส่วนตัว</a>
                `
    },
    {
        id: 14,
        name: 'การแก้ไขข้อตกลง',
        content: `
            <p class="mb-0">
            ผู้ให้บริการอาจแก้ไขหรือปรับปรุงข้อตกลงนี้เป็นครั้งคราว เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของบริการ กฎหมาย หรือข้อกำหนดที่เกี่ยวข้อง
            <br/>ข้อตกลงฉบับแก้ไขจะมีผลตั้งแต่วันที่ระบุไว้ในประกาศ เว้นแต่กฎหมายหรือข้อกำหนดที่เกี่ยวข้องจะกำหนดเป็นอย่างอื่น
            </p>
        `
    },
    {
        id: 15,
        name: 'กฎหมายที่ใช้บังคับ',
        content: `ข้อตกลงนี้อยู่ภายใต้บังคับและการตีความตามกฎหมายของประเทศไทย เว้นแต่กฎหมายที่ใช้บังคับจะกำหนดไว้เป็นอย่างอื่น`
    },
    {
        id: 16,
        name: 'ติดต่อผู้ให้บริการ',
        content: `หากมีคำถามเกี่ยวกับข้อตกลงและเงื่อนไข สามารถติดต่อได้ที่
        ${stringContact()}`
    },
]



